module.exports = __webpack_public_path__ + "img/box-pencil.8a84bbff.svg";